module.exports = __webpack_public_path__ + "media/images/Perfectmatch-Plan-Banner-3baa5b8254514afe36181d9c55ea72f4.jpg";